/* ==========================================================================
   Dawn media-gallery (ES5 safe)
   ========================================================================== */

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    function () {
      function MediaGallery() {
        var _this = this;
        HTMLElement.call(this);

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(function (event) { _this.onSlideChanged(event); }, 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach(function (mediaToSwitch) {
            var btn = mediaToSwitch.querySelector('button');
            if (!btn) return;
            btn.addEventListener(
              'click',
              _this.setActiveMedia.bind(_this, mediaToSwitch.dataset.target, false)
            );
          });

        if (this.dataset.desktopLayout && this.dataset.desktopLayout.indexOf('thumbnail') !== -1 && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      MediaGallery.prototype = Object.create(HTMLElement.prototype);
      MediaGallery.prototype.constructor = MediaGallery;

      MediaGallery.prototype.onSlideChanged = function (event) {
        if (!this.elements.thumbnails) return;
        var cur = event && event.detail && event.detail.currentElement;
        var mediaId = cur && cur.dataset && cur.dataset.mediaId;
        if (!mediaId) return;

        var thumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
        this.setActiveThumbnail(thumbnail);
      };

      MediaGallery.prototype.setActiveMedia = function (mediaId, prepend) {
        var activeMedia = this.elements.viewer.querySelector('[data-media-id="' + mediaId + '"]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            var thumb = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
            if (thumb) thumb.parentElement.prepend(thumb);
          }

          // guard resetPages / reset
          var s = this.elements.viewer.slider;
          if (s) {
            if (typeof s.resetPages === 'function') s.resetPages();
            else if (typeof s.reset === 'function') s.reset();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(
          function () {
            if (this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          }.bind(this)
        );

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        var activeThumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      };

      MediaGallery.prototype.setActiveThumbnail = function (thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach(function (el) {
          el.removeAttribute('aria-current');
        });

        var btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        if (this.elements.thumbnails.slider && this.elements.thumbnails.slider.scrollTo) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      };

      MediaGallery.prototype.announceLiveRegion = function (activeItem, position) {
        var image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;

        image.onload = function () {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(
            function () { this.elements.liveRegion.setAttribute('aria-hidden', true); }.bind(this),
            2000
          );
        }.bind(this);

        image.src = image.src;
      };

      MediaGallery.prototype.playActiveMedia = function (activeItem) {
        if (window.pauseAllMedia) window.pauseAllMedia();
        var deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
      };

      MediaGallery.prototype.preventStickyHeader = function () {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      };

      MediaGallery.prototype.removeListSemantic = function () {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach(function (slide) {
            slide.setAttribute('role', 'presentation');
          });
        }
      };

      return MediaGallery;
    }()
  );
}

/* ==========================================================================
   Variant → Gallery filter (SECTION-AWARE + EVENT-DETAIL)  (ES5 safe)
   ========================================================================== */

(function () {
  function escapeCssId(id) {
    // minimal escape for CSS selector usage
    return String(id).replace(/(["\\#.:,[\]=>~+*^$(){}|])/g, '\\$1');
  }

  function getSectionKeyFromGallery(mg) {
    var id = String((mg && mg.id) || '');
    if (id.indexOf('MediaGallery-') !== 0) return '';
    var key = id.slice('MediaGallery-'.length);
    if (key.slice(-'-duplicate'.length) === '-duplicate') key = key.slice(0, -'-duplicate'.length);
    return key;
  }

  function getContextRoot(mg) {
    var sectionKey = getSectionKeyFromGallery(mg);
    return (sectionKey && document.getElementById('MainProduct-' + sectionKey)) || document;
  }

  function getVariantIdForGallery(mg) {
    var root = getContextRoot(mg);
    var idInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    var global = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (global && global.value) return String(global.value);

    try {
      var url = new URL(window.location.href);
      var v = url.searchParams.get('variant');
      if (v) return String(v);
    } catch (e) {}

    return '';
  }

  function getVariantColorMapElement(mg) {
    var sectionKey = getSectionKeyFromGallery(mg);
    if (sectionKey) {
      var exact = document.querySelector(
        'script#VariantColorMap-' + escapeCssId(sectionKey) + '[type="application/json"],' +
        'script#VariantColorMap-' + escapeCssId(sectionKey) + '-duplicate[type="application/json"]'
      );
      if (exact) return exact;
    }

    var primary = document.querySelector(
      'script[id^="VariantColorMap-"][type="application/json"]:not([id$="-duplicate"])'
    );
    return primary || document.querySelector('script[id^="VariantColorMap-"][type="application/json"]');
  }

  function getColorFromVariantId(variantId, mg) {
    if (!variantId) return '';
    var mapEl = getVariantColorMapElement(mg);
    if (!mapEl) return '';

    try {
      var map = JSON.parse(mapEl.textContent || '{}');
      var v = map[variantId] || '';
      return String(v).trim().toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function ensureFilterStyle(mg) {
    var styleId = 'GalleryFilterStyle-' + ((mg && mg.id) || 'unknown');
    var styleEl = mg.querySelector('style#' + escapeCssId(styleId));
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      mg.prepend(styleEl);
    }
    return styleEl;
  }

  function escapeAttrValue(v) {
    return String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function hasColorMatch(mg, color) {
    if (!color) return false;
    var lc = String(color).trim().toLowerCase();
    var items = mg.querySelectorAll('.product__media-item[data-media-scope="color"][data-media-color]');
    for (var i = 0; i < items.length; i++) {
      var c = String(items[i].getAttribute('data-media-color') || '').trim().toLowerCase();
      if (c === lc) return true;
      if ((lc === 'weiß' || lc === 'weiss') && (c === 'weiß' || c === 'weiss')) return true;
    }
    return false;
  }

  function writeScopedCss(mg, color) {
    var styleEl = ensureFilterStyle(mg);
    var gid = '#' + escapeCssId(mg.id);

    var lc = String(color || '').trim().toLowerCase();
    mg.setAttribute('data-selected-color', lc);

    var baseHide =
      gid + ' .product__media-item, ' +
      gid + ' .thumbnail-list__item { display:none !important; }';

    if (lc && hasColorMatch(mg, lc)) {
      var c = escapeAttrValue(lc);
      styleEl.textContent =
        baseHide +
        '\n' + gid + ' [data-media-scope="general"] { display:block !important; }' +
        '\n' + gid + ' [data-media-scope="color"][data-media-color="' + c + '"] { display:block !important; }';
    } else {
      styleEl.textContent =
        baseHide +
        '\n' + gid + ' [data-media-scope="general"] { display:block !important; }';
    }
  }

  function findPreferredTargetInViewer(mg) {
    var lc = String(mg.getAttribute('data-selected-color') || '').trim().toLowerCase();
    var viewer = mg.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return '';

    if (lc) {
      var slides = viewer.querySelectorAll('.product__media-item[data-media-scope="color"][data-media-color]');
      for (var i = 0; i < slides.length; i++) {
        var c = String(slides[i].getAttribute('data-media-color') || '').trim().toLowerCase();
        if (c === lc || ((lc === 'weiß' || lc === 'weiss') && (c === 'weiß' || c === 'weiss'))) {
          var sid = slides[i].id || '';
          if (sid.indexOf('Slide-') === 0) return sid.slice('Slide-'.length);
        }
      }
    }

    var general = viewer.querySelector('.product__media-item[data-media-scope="general"]');
    if (!general) return '';
    var gid = general.id || '';
    if (gid.indexOf('Slide-') === 0) return gid.slice('Slide-'.length);
    return '';
  }

  function clickThumbByTarget(mg, target) {
    var thumbs = mg.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return false;
    var item = thumbs.querySelector('[data-target="' + target + '"]');
    if (!item) return false;
    var btn = item.querySelector('button');
    if (!btn) return false;
    btn.click();
    return true;
  }

  function findPreferredSlideEl(mg) {
    var lc = String(mg.getAttribute('data-selected-color') || '').trim().toLowerCase();
    var viewer = mg.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return null;

    // 1) bevorzugt: color-slide passend zur Auswahl
    if (lc) {
      var slides = viewer.querySelectorAll('.product__media-item[data-media-scope="color"][data-media-color]');
      for (var i = 0; i < slides.length; i++) {
        var c = String(slides[i].getAttribute('data-media-color') || '').trim().toLowerCase();
        if (c === lc) return slides[i];
        if ((lc === 'weiß' || lc === 'weiss') && (c === 'weiß' || c === 'weiss')) return slides[i];
      }
    }

    // 2) fallback: first general
    var general = viewer.querySelector('.product__media-item[data-media-scope="general"]');
    if (general) return general;

    // 3) last resort: first slide
    return viewer.querySelector('.product__media-item');
  }


  function syncActiveState(mg) {
    var viewer = mg.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var preferred = findPreferredSlideEl(mg);
    if (!preferred) return;

    // remove old active
    var all = viewer.querySelectorAll('.product__media-item.is-active');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');

    // mark preferred active
    preferred.classList.add('is-active');

    // IMPORTANT: make it the "main" by moving it to the front
    // (your layout has no thumbnails; first visible/first DOM is what users perceive as main)
    try {
      var list = preferred.parentElement;
      if (list && list.firstElementChild !== preferred) {
        list.prepend(preferred);
      }
    } catch (e) {}

    // if slider exists, reset pages (optional)
    try {
      var s = viewer.slider;
      if (s) {
        if (typeof s.resetPages === 'function') s.resetPages();
        else if (typeof s.reset === 'function') s.reset();
      }
    } catch (e2) {}

    // ensure it is visible (stacked layouts)
    try { preferred.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e3) {}
  }


  function applyForGallery(mg, variantIdOverride) {
    var mapEl = getVariantColorMapElement(mg);
    if (!mapEl) return;

    var variantId = variantIdOverride || getVariantIdForGallery(mg);
    var color = getColorFromVariantId(variantId, mg);
    if (!color) return;

    writeScopedCss(mg, color);
    syncActiveState(mg);
  }

  function run(variantIdOverride) {
    var galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-"]');
    for (var i = 0; i < galleries.length; i++) {
      applyForGallery(galleries[i], variantIdOverride);
    }
  }

  function hook() {
    run();

    function delayedRun(vid) {
      window.setTimeout(function () { run(vid || undefined); }, 0);
      window.setTimeout(function () { run(vid || undefined); }, 80);
      window.setTimeout(function () { run(vid || undefined); }, 200);
      window.setTimeout(function () { run(vid || undefined); }, 450);
    }

    document.addEventListener('variant:change', function (e) {
      var vid = (e && e.detail && e.detail.variant && e.detail.variant.id) ? String(e.detail.variant.id) : '';
      delayedRun(vid);
    });

    document.addEventListener('product:variant-change', function (e) {
      var vid = (e && e.detail && e.detail.variant && e.detail.variant.id) ? String(e.detail.variant.id) : '';
      delayedRun(vid);
    });

    document.addEventListener('change', function (e) {
      var t = e && e.target;
      if (t && (t.name === 'id' || (t.closest && t.closest('form[action*="/cart/add"]')))) {
        window.setTimeout(function () { run(); }, 0);
      }
    });

    document.addEventListener('input', function (e) {
      var t = e && e.target;
      if (t && t.name === 'id') window.setTimeout(function () { run(); }, 0);
    });

    document.addEventListener('click', function (e) {
      var t = e && e.target;
      if (t && t.closest && t.closest('[data-option-value], .swatch, .product-form__input')) {
        window.setTimeout(function () { run(); }, 0);
        window.setTimeout(function () { run(); }, 80);
        window.setTimeout(function () { run(); }, 200);
      }
    });

    var idInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (var i = 0; i < idInputs.length; i++) {
      new MutationObserver(function () {
        window.setTimeout(function () { run(); }, 0);
      }).observe(idInputs[i], { attributes: true, attributeFilter: ['value'] });
    }

    window.addEventListener('popstate', function () {
      window.setTimeout(function () { run(); }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
